import { IsOptional, IsInt } from 'class-validator';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Type } from 'class-transformer';

/**
 * DTO para filtrar el Dashboard de Servicio Integral.
 * Permite filtrar por cliente y temporada.
 *
 * **Default**: Si no se especifica temporadaId, usa la temporada en curso.
 */
export class DashboardServicioIntegralFilterDto {
  /**
   * ID del cliente a filtrar (opcional, todos si no se especifica).
   * - Cliente: solo puede ver su propio ID.
   * - Admin/Superuser: puede seleccionar cualquier cliente.
   */
  @ApiPropertyOptional({
    description:
      'ID del cliente a filtrar (opcional, todos si no se especifica)',
    example: 66,
    type: Number,
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  clienteId?: number;

  /**
   * ID de la temporada a consultar.
   * Si no se especifica, usa la temporada en curso (fecha actual entre SeasonFrom y SeasonTo).
   * Las fechas de inicio y fin se obtienen automáticamente de la temporada.
   */
  @ApiPropertyOptional({
    description:
      'ID de la temporada (opcional, usa temporada en curso si no se especifica)',
    example: 7,
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  temporadaId?: number;
}
